import { resolveUploadsUrl } from '@/lib/resolve-uploads-url';

/** Couverture par défaut des formations sans image (fichier public Vite). */
export const DEFAULT_FORMATION_COVER_PATH = '/PreviewFormation.png';

/** URL affichable pour une couverture formation (uploads ou défaut LyrraOne). */
export function resolveFormationCoverUrl(coverImageUrl?: string | null): string {
  const raw = coverImageUrl?.trim();
  if (!raw) return DEFAULT_FORMATION_COVER_PATH;
  return resolveUploadsUrl(raw) ?? raw;
}

export function hasCustomFormationCover(coverImageUrl?: string | null): boolean {
  return Boolean(coverImageUrl?.trim());
}

/** Couverture funnel : hero custom > couverture formation (défaut LyrraOne) > produit. */
export function resolveFunnelOfferCoverUrl(
  offer: { kind: string; coverImageUrl?: string | null },
  heroCoverUrl?: string | null,
): string {
  const hero = heroCoverUrl?.trim();
  if (hero) return resolveUploadsUrl(hero) ?? hero;
  if (offer.kind === 'formation') return resolveFormationCoverUrl(offer.coverImageUrl);
  const raw = offer.coverImageUrl?.trim();
  return raw ? (resolveUploadsUrl(raw) ?? raw) : '';
}
